import Spinner from 'components/Spinner/Spinner'
import {
  OauthPlatform,
  Platform,
  useAddMediaAccountMutation,
  useGetOauthTokensQuery,
} from 'graphql/generated/graphql'
import { usePageNavigation } from 'hooks/useNavigation'
import React, { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function TikTok(): JSX.Element {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const { navigateToDashboard } = usePageNavigation()
  const firstTime = useRef(true)
  const [addMediaAccount, { loading: addMediaLoading }] =
    useAddMediaAccountMutation()

  const { loading, data } = useGetOauthTokensQuery({
    variables: {
      code: code ?? '',
      platform: OauthPlatform.TikTok,
    },
    skip: !code,
  })

  useEffect(() => {
    if (data?.oauth?.accessToken && firstTime.current) {
      firstTime.current = false
      localStorage.setItem('tiktokToken', data.oauth.accessToken)

      addMediaAccount({
        variables: {
          accessToken: data.oauth.accessToken,
          platform: Platform.TikTok,
          refreshToken: data.oauth.refreshToken,
        },
      })
        .then(() => {
          navigateToDashboard()
        })
        .catch((e) => console.error('TikTok account connection failed:', e))
    }
  }, [data, addMediaAccount, navigateToDashboard])

  if (!code) return <>Missing Code</>
  if (loading || addMediaLoading) return <Spinner />
  if (!data) return <>Something went wrong</>

  return <>Successful</>
}
